import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from './RequireAuth'
import { RequireRole } from './RequireRole'
import { IndexRedirect } from './IndexRedirect'
import { AdminLayout } from '../components/AdminLayout'
import { AdminNotFound } from '../components/admin/AdminNotFound'
import { AdminLoginPage } from '../pages/AdminLoginPage'
import { DashboardPage } from '../pages/DashboardPage'
import { VcardListPage } from '../pages/VcardListPage'
import { BrandListPage } from '../pages/BrandListPage'
import { BrandEditorPage } from '../pages/BrandEditorPage'
import { AccountListPage } from '../pages/AccountListPage'
import { AccountDetailPage } from '../pages/AccountDetailPage'
import { BrandDomainsPage } from '../pages/BrandDomainsPage'

/**
 * Router-Teilbaum unter /admin/* (Management-Konsole, TP2 §2). Ein gemeinsamer
 * Guard-/Shell-Rahmen: RequireAuth → AdminLayout (BMC/shadcn) → rollenabhängige
 * Verwaltungsseiten. Seiten-Inhalte bleiben interim AntD (TP3/TP5).
 */
export function AdminRoutes() {
  return (
    <Routes>
      {/* Admin-Login (F2-Split): Passwort+OTP, anonym erreichbar (TP2 §D4). */}
      <Route path="login" element={<AdminLoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AdminLayout />}>
          <Route index element={<IndexRedirect />} />

          {/* admin + brand-admin: Dashboard, Nutzer, vCards, Brand-Editor */}
          <Route element={<RequireRole roles={['admin', 'brand-admin']} />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="accounts" element={<AccountListPage />} />
            <Route path="accounts/:id" element={<AccountDetailPage />} />
            <Route path="vcards" element={<VcardListPage />} />
            <Route path="brands/:brandKey" element={<BrandEditorPage />} />
          </Route>

          {/* nur admin: Brand-Liste + Domain-Verwaltung (brand-admin darf eigene
              Domains NICHT selbst verwalten). /admin/domains → Marken-Auswahl. */}
          <Route element={<RequireRole roles={['admin']} />}>
            <Route path="brands" element={<BrandListPage />} />
            <Route path="brands/:brandKey/domains" element={<BrandDomainsPage />} />
            <Route path="domains" element={<BrandDomainsPage />} />
          </Route>

          {/* nur brand-admin: eigenes Brand-Profil (Shortcut) */}
          <Route element={<RequireRole roles={['brand-admin']} />}>
            <Route path="brand" element={<BrandEditorPage />} />
          </Route>
        </Route>
      </Route>

      {/* Bereichs-404 der Konsole (außerhalb der Shell). */}
      <Route path="*" element={<AdminNotFound />} />
    </Routes>
  )
}
